import { render, staticRenderFns } from "./CreativesTable.vue?vue&type=template&id=5ee62dfa&scoped=true&"
import script from "./CreativesTable.vue?vue&type=script&lang=ts&"
export * from "./CreativesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee62dfa",
  null
  
)

export default component.exports